import Question from './Question'

// this.value 存的是被選到的 optionId
export class Radio extends Question {
  get isValueDefault () { return this.defaultValue && (this.defaultValue === this.value) }

  get optionIds () { return this._questionDefinition.options }

  get options () { return this.optionIds.map(oid => this.cartElementBuilder.buildOption(oid, this.stateObj, this._menu)) }

  get currentLevelPrice () { return parseFloat(this.value ? this.options.find(o => o.id === this.value).price : 0) }
  get totalPrice () { return parseFloat(this.value ? this.options.find(o => o.id === this.value).totalPrice : 0) }
  get selectedOption () { return this.value ? this.options.find(o => o.id === this.value) : undefined }
  get selectedOptions () { return this.value ? [this.options.find(o => o.id === this.value)] : [] }
  get selectedOptionId () { return this.selectedOption ? this.selectedOption.id : undefined }
  get activeSubQuestions () { return this.selectedOption ? this.selectedOption.questions : [] }

  get valueString () {
    if (!this.selectedOption) { return this.title + '尚未選擇' }
    return this.selectedOption.title
  }

  get valueStringWithTitle () {
    if (!this.selectedOption) { return this.title + ': 請選擇' }
    return this.title ? this.title + ': ' + this.selectedOption.title : this.selectedOption.title
  }
  get isValid () { return this.hasValue }
  get inValidQuestions () { return this.isValid ? this.selectedOption.inValidQuestions : [this.title] }

  get errorMessage () { return '點我選: ' + this.title }
}
